var render = function render(){var _vm=this,_c=_vm._self._c;return _c('digi-input',{attrs:{"type":"tel","label":"Mobile phone number","name":_vm.name,"rules":this.$getValidationRules(this.name),"custom-messages":this.$getValidationMessages(this.name),"attributes":{ 'maxlength': 13 }},model:{value:(_vm.thisValue),callback:function ($$v) {_vm.thisValue=$$v},expression:"thisValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }